import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear(event) {
    event.preventDefault()
    const form = this.element
    form.reset()
    form.requestSubmit()
  }
}